import {Box, Typography, alpha, styled} from '@mui/material';

export const IconContainer = styled(Box)`
	background-color: ${({theme}) => alpha(theme.palette.success.light, 0.2)};
	color: ${({theme}) => theme.palette.success.light};
	border-radius: 50%;
	padding: 8px;
	display: flex;
`;

export const StyledTypography = styled(Typography)`
	color: ${({theme}) => theme.palette.primary['900']};
`;
